import React from "react";
import { Helmet } from "react-helmet";
import { ENABLE_TRACKING, GA_MEASUREMENT_ID, GTM_ID, URL } from "src/Config/appConfig";

const isEnquiry = window.location.pathname === URL.ENQUIRY;

class HelmetWrapper extends React.Component {
    public componentDidMount() {
        if (ENABLE_TRACKING) {
            const gtmId = isEnquiry ? GTM_ID.ENQUIRY : GTM_ID.PORTAL;
            const script = document.createElement("script");
            const noscript = document.createElement("noscript");
            script.innerHTML = `
                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','${gtmId}');
            `;
            noscript.innerHTML = `
                <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
                height="0" width="0" style="display:none;visibility:hidden"></iframe>
            `;
            document.head.insertBefore(script, document.head.childNodes[0]);
            document.body.insertBefore(noscript, document.body.childNodes[0]);
        }
    }

    public render() {
        const { children } = this.props;
        const measurementId = isEnquiry ? GA_MEASUREMENT_ID.ENQUIRY : GA_MEASUREMENT_ID.PORTAL;

        return (
            <>
                {
                    ENABLE_TRACKING &&
                    <Helmet>
                        <script async src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`} />
                        <script>
                            {`
                                window.dataLayer = window.dataLayer || [];
                                function gtag(){dataLayer.push(arguments);}
                                gtag('js', new Date());
                                gtag('config', '${measurementId}');
                            `}
                        </script>
                    </Helmet>
                }
                {children}
            </>
        );
    }
}

export default HelmetWrapper;



// WEBPACK FOOTER //
// ./src/Components/HelmetWrapper/HelmetWrapper.tsx